import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'corporateBalance'
})
export class CorporateBalancePipe implements PipeTransform {

  transform(value: number | string): string {
    if (value == null) return '0';

    // 🔹 Agar value string hai (₹, $, commas) → clean & convert
    const amount =
      typeof value === 'string'
        ? Number(value.replace(/[^\d.-]/g, ''))
        : value;

    if (isNaN(amount)) return '0';

    // ≥ 1 Crore
    if (amount >= 10000000) {
      const cr = amount / 10000000;
      return `${cr % 1 === 0 ? cr : cr.toFixed(2)} Cr`;
    }

    // ≥ 1 Lakh
    if (amount >= 100000) {
      const lakh = amount / 100000;
      return `${lakh % 1 === 0 ? lakh : lakh.toFixed(2)} Lakh`;
    }

    // Normal number
    return amount.toLocaleString('en-IN');
  }

}
